import { useEffect, useState } from "react";
import AdminTopNavBar from "../common/AdminTopNavBar";
import getUserMenuItems from "./AdminMenuContent";
import AdminSideBar from "./AdminSideBar";
import { adminReqConfig, api, baseURL } from "../../include/api";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import AdminFooter from "../common/AdminFooter";
import "../../styles/CategoryProductList.css";
import { useNotification } from "../../Toast/ToastProvider";
import { ChevronDown,X } from "react-feather";
import { ERROR, SUCCESS } from "../../include/constant";
import Papa from "papaparse";
import { useRef } from "react";
import { Trash2 } from "react-feather";
import { getAdmin } from "../../include/function";

const ListCategory = () => {
  const navigate = useNavigate();
  const homeLink = "/admin";
  const [fetchLoading, setFetchLoading] = useState(true);
  const [categoryList, setCategoryList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [isSidebarMinimized, setIsSidebarMinimized] = useState(false);
  const toggleSidebar = () => setIsSidebarMinimized(!isSidebarMinimized);
  const menuContent = getUserMenuItems();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const toast = useNotification();
  const [importPreview, setImportPreview] = useState([]);
  const [fileMap, setFileMap] = useState({});
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [isImportInstructionsOpen, setIsImportInstructionsOpen] =
    useState(false);
  const [parentCategories, setParentCategories] = useState([]); // only top-level
  const [searchParams] = useSearchParams();
  const initialQuery = searchParams.get("q") || "";
  const [searchQuery, setSearchQuery] = useState(initialQuery);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  useEffect(() => {
    const q = searchParams.get("q") || "";
    setSearchQuery(q);
  }, [searchParams]);
  const [filterValues, setFilterValues] = useState({
    status: "",
  });
  const fileInputRef = useRef(null);
  const user = getAdmin();
  const [productPermissions, setProductPermissions] = useState({
    add: false,
    view: false,
    edit: false,
    delete: false,
  });

  console.log("categoryList", categoryList);

  useEffect(() => {
    const fetchPermissions = async () => {
      if (!user?.roleId) return;

      try {
        const res = await api.get(
          `/role_permission/?roleId=${user.roleId}`,
          adminReqConfig(),
        );
        if (res.status === 200 && Array.isArray(res.data.data)) {
          // Find permission entry where pageTitle === "Product"
          const productPerm = res.data.data.find(
            (p) => p.pageTitle === "Category",
          );

          if (productPerm) {
            setProductPermissions({
              add: productPerm.add === "true" || productPerm.add === 1,
              view: productPerm.view === "true" || productPerm.view === 1,
              edit: productPerm.edit === "true" || productPerm.edit === 1,
              delete: productPerm.delete === "true" || productPerm.delete === 1,
            });
          }
        }
      } catch (err) {
        console.warn("Failed to fetch product permissions", err);
      }
    };

    fetchPermissions();
  }, [user?.roleId]);
  useEffect(() => {
    getCategory();
  }, []);

  let currentItems = [];
  let totalPage = 1;
  let showingFrom = 0;
  let showingTo = 0;

  if (itemsPerPage === "all") {
    currentItems = filteredData;
    showingFrom = filteredData.length > 0 ? 1 : 0;
    showingTo = filteredData.length;
  } else {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    totalPage = Math.ceil(filteredData.length / itemsPerPage);
    showingFrom = indexOfFirstItem + 1;
    showingTo = Math.min(indexOfLastItem, filteredData.length);
  }
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleView = (categoryId) => {
    navigate(`/admin/category/categoryAddNew?id=${categoryId}&view=true`);
  };

  const handleEdit = (categoryId) => {
    navigate(`/admin/category/categoryAddNew?id=${categoryId}`);
  };
  const handleDelete = (categoryId) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      api
        .delete(`/category/?id=${categoryId}`, adminReqConfig())
        .then((response) => {
          if (response) {
            toast({ type: SUCCESS, message: response.data.message });

            setCategoryList((prev) => prev.filter((p) => p.id !== categoryId));
            setFilteredData((prev) => prev.filter((p) => p.id !== categoryId));
          }
        })
        .catch((error) => {
          toast({ type: ERROR, message: "Failed to delete category" });
          console.error("Delete error:", error);
        });
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      // Select all current page category IDs
      setSelectedData(currentItems.map((p) => p.id));
    } else {
      // Remove current page category IDs
      setSelectedData((prev) =>
        prev.filter((id) => !currentItems.map((p) => p.id).includes(id)),
      );
    }
  };

  const handleSelectOne = (id) => {
    setSelectedData((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id],
    );
  };

  const getCategory = (afterGet) => {
    setFetchLoading(true);
    api
      .get("/category/", adminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          const allCategories = response.data.data;

          // Filter only top-level categories (parentId === 0)
          const topLevelCategories = allCategories.filter(
            (cat) => cat.parentId === 0,
          );

          setCategoryList(allCategories);
          setFilteredData(topLevelCategories);

          if (afterGet) afterGet(topLevelCategories);
        }
      })
      .catch((error) => {
        setCategoryList([]);
        if (afterGet) afterGet([]);
      })
      .finally(() => setFetchLoading(false));
  };
  useEffect(() => {
    let filtered = categoryList.filter((cat) => cat.parentId === 0); // Only top-level

    // Apply search
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim();
      filtered = filtered.filter((cat) =>
        cat.name?.toLowerCase().includes(query),
      );
    }

    // Apply status filter
    if (filterValues.status) {
      filtered = filtered.filter((cat) => cat.status === filterValues.status);
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [searchQuery, filterValues.status, categoryList, searchParams]);
  const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "27px",
          height: "27px",
          borderRadius: "50%",
          backgroundColor: "#6C757D",
          border: "none",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
          zIndex: 1000,
          position: "absolute",
          top: "calc(40px + 30px + 10px)",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="#FFFFFF"
          viewBox="0 0 16 16"
        >
          {" "}
          {/* White Icon */}
          <path d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
        </svg>
      </div>
    );
  };
  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "27px",
          height: "27px",
          borderRadius: "50%",
          backgroundColor: "#6C757D",
          border: "none",
          zIndex: 1000,
          position: "absolute",
          top: "calc(40px + 30px + 10px)",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="#FFFFFF"
          viewBox="0 0 16 16"
        >
          {" "}
          {/* White Icon */}
          <path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
    );
  };
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true, // Auto play enabled
    autoplaySpeed: 3000,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const handleDownloadCSV = async (exportScope = "current") => {
    let categoryIdsToExport = [];

    // ✅ PRIORITY 1: If items selected → ALWAYS export selected (overrides everything)
    if (selectedData.length > 0) {
      categoryIdsToExport = selectedData;
    }
    // ✅ PRIORITY 2: If "Export All" clicked → export entire dataset
    else if (exportScope === "all") {
      categoryIdsToExport = categoryList.map((p) => p.id);
    }
    // ✅ PRIORITY 3: Default → export current page items only
    else {
      categoryIdsToExport = currentItems.map((p) => p.id);
    }

    if (categoryIdsToExport.length === 0) {
      toast({ type: "error", message: "No Category data to download" });
      return;
    }

    setFetchLoading(true);
    try {
      // Fetch all specs for the categories being exported
      const specPromises = categoryIdsToExport.map((id) =>
        api
          .get(`/category_specification/?categoryId=${id}`, adminReqConfig())
          .then((res) => ({ categoryId: id, specs: res.data.data || [] }))
          .catch(() => ({ categoryId: id, specs: [] })),
      );
      const specsResults = await Promise.all(specPromises);
      const specsMap = {};
      specsResults.forEach(({ categoryId, specs }) => {
        specsMap[categoryId] = specs;
      });

      // Build flat CSV rows: one row per spec (or one row if no specs)
      const csvRows = [];
      const headers = [
        "Name",
        "Description",
        "Status",
        "SpecGroup",
        "SpecTitle",
        "SpecType",
        "SpecOptions",
      ];

      categoryList
        .filter((p) => categoryIdsToExport.includes(p.id))
        .forEach((category) => {
          const specs = specsMap[category.id] || [];
          const baseRow = {
            Name: category.name || "",
            Description: category.description || "",
            Status: category.status === "active" ? "active" : "inactive",
          };

          if (specs.length === 0) {
            csvRows.push({
              ...baseRow,
              SpecGroup: "",
              SpecTitle: "",
              SpecType: "",
              SpecOptions: "",
            });
          } else {
            specs.forEach((spec) => {
              csvRows.push({
                ...baseRow,
                SpecGroup: spec.groupName || "General",
                SpecTitle: spec.title || "",
                SpecType: spec.fieldType || "",
                SpecOptions:
                  spec.fieldType === "TEXT" ? "" : spec.options || "",
              });
            });
          }
        });

      // Escape and stringify CSV
      const escapeCsvField = (field) => {
        if (field == null) return "";
        const str = String(field);
        return str.includes(",") || str.includes('"') || str.includes("\n")
          ? `"${str.replace(/"/g, '""')}"`
          : str;
      };

      const csvContent = [
        headers.join(","),
        ...csvRows.map((row) =>
          headers.map((h) => escapeCsvField(row[h])).join(","),
        ),
      ].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // ✅ Dynamic filename based on export type
      const fileName =
        selectedData.length > 0
          ? `Category_Selected_${selectedData.length}.csv`
          : exportScope === "all"
            ? "Category_All.csv"
            : `Category_Page${currentPage}.csv`;

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Export error:", error);
      toast({ type: ERROR, message: "Failed to export with specifications." });
    } finally {
      setFetchLoading(false);
    }
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.name.endsWith(".csv")) {
      toast({ type: ERROR, message: "Please upload a CSV file." });
      return;
    }
    setFetchLoading(true);
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const { data } = results;
        if (data.length === 0) {
          toast({ type: ERROR, message: "CSV file is empty." });
          setFetchLoading(false);
          return;
        }

        // Map to editable preview rows
        const previewList = data
          .filter((row) => (row.Name || "").trim())
          .map((row, idx) => ({
            id: `${Date.now()}-${idx}`,
            Name: (row.Name || "").trim(),
            Description: (row.Description || "").trim(),
            Status: ["active", "1", "true"].includes(
              (row.Status || "").toLowerCase(),
            )
              ? "active"
              : "inactive",
            specs: [], // will be populated from CSV
          }));

        if (previewList.length === 0) {
          toast({ type: ERROR, message: "No valid categories found in CSV." });
          setFetchLoading(false);
          return;
        }

        setImportPreview(previewList);
        setFetchLoading(false);
        setIsImportModalOpen(true);
      },
      error: (error) => {
        console.error("CSV Parse Error:", error);
        toast({ type: ERROR, message: "Failed to parse CSV file." });
        setFetchLoading(false);
      },
    });
  };
  const handlePreviewFieldChange = (id, field, value) => {
    setImportPreview((prev) =>
      prev.map((row) => (row.id === id ? { ...row, [field]: value } : row)),
    );
  };
  const handleStartImport = async () => {
    if (importPreview.length === 0) return;
    setFetchLoading(true);
    let successCount = 0;
    let errorCount = 0;

    for (const item of importPreview) {
      const { Name, Description, Status, specs = [], id } = item;
      const name = Name?.trim();
      if (!name) {
        errorCount++;
        continue;
      }

      try {
        // === Step 1: Create Category ===
        const formData = new FormData();
        formData.append("name", name);
        formData.append("description", Description?.trim() || "");
        formData.append(
          "status",
          Status?.toLowerCase() === "active" ? "active" : "inactive",
        );
        formData.append("parentId", "0"); // top-level
        const selectedFile = fileMap[id];
        if (selectedFile) {
          formData.append("image", selectedFile);
        }

        const catRes = await api.post("/category/", formData, {
          ...adminReqConfig(),
          headers: { ...adminReqConfig().headers, "Content-Type": undefined },
        });

        if (![200, 201].includes(catRes.status)) {
          errorCount++;
          continue;
        }

        const savedCategoryId = catRes.data.data?.id;
        if (!savedCategoryId) {
          errorCount++;
          continue;
        }

        // === Step 2: Save Specifications (aligned with AddCategory logic) ===
        if (specs && specs.length > 0) {
          // Validate and normalize specs exactly like AddCategory
          const validSpecs = specs.filter((spec) => {
            const title = (spec.title || "").trim();
            const fieldType = (spec.fieldType || "").trim();
            const options = (spec.options || "").trim();

            // Allowed field types (must match AddCategory dropdown)
            const validFieldTypes = [
              "TEXT",
              "DROPDOWN LIST",
              "CHECKBOX",
              "RADIO BUTTON",
            ];
            const isValidType = validFieldTypes.includes(fieldType);

            if (!title || !isValidType) return false;

            // For TEXT, options are ignored (must be empty)
            if (fieldType === "TEXT") return true;

            // For others, options must be non-empty string
            return options.length > 0;
          });

          if (validSpecs.length > 0) {
            // Group by groupName (default to "General" if missing/empty)
            const groups = {};
            validSpecs.forEach((spec) => {
              const groupName = (spec.groupName || "").trim() || "General";
              if (!groups[groupName]) groups[groupName] = [];
              groups[groupName].push(spec);
            });

            // Send each spec
            const specPromises = Object.entries(groups).flatMap(
              ([groupName, groupSpecs]) =>
                groupSpecs.map((spec) =>
                  api.post(
                    "/category_specification/",
                    {
                      categoryId: savedCategoryId,
                      groupName: groupName,
                      title: spec.title.trim(),
                      fieldType: spec.fieldType.trim(),
                      options:
                        spec.fieldType.trim() === "TEXT"
                          ? ""
                          : (spec.options || "").trim(),
                    },
                    adminReqConfig(),
                  ),
                ),
            );

            await Promise.all(specPromises);
          }
        }

        successCount++;
      } catch (err) {
        console.error("Import failed for:", Name, err);
        errorCount++;
      }
    }

    // === Final feedback ===
    if (successCount > 0) {
      toast({
        type: SUCCESS,
        message: `${successCount} category(ies) imported successfully with specifications!`,
      });
      getCategory();
      setImportPreview([]);
      setFileMap({});
    }
    if (errorCount > 0) {
      toast({
        type: ERROR,
        message: `${errorCount} failed. Check CSV format and spec columns.`,
      });
    }
    if (successCount === 0 && errorCount === 0) {
      toast({ type: ERROR, message: "No valid categories to import." });
    }
    setFetchLoading(false);
    setIsImportModalOpen(false);
  };
  const handleStatusChange = (categoryId, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    const payload = { status: newStatus };
    api
      .put(
        `/category/?id=${categoryId}&flag=changeStatus`,
        payload,
        adminReqConfig(),
      )
      .then((response) => {
        if (response.status === 200) {
          toast({
            type: SUCCESS,
            message: `Category ${newStatus} successfully!`,
          });
          setCategoryList((prev) =>
            prev.map((p) =>
              p.id === categoryId ? { ...p, status: newStatus } : p,
            ),
          );
          setFilteredData((prev) =>
            prev.map((p) =>
              p.id === categoryId ? { ...p, status: newStatus } : p,
            ),
          );
        }
      })
      .catch((error) => {
        console.error("Status update failed:", error);
        toast({ type: ERROR, message: "Failed to update product status." });
      });
  };
  const handleDownloadSampleCSV = () => {
    const sampleHeaders = [
      "Name",
      "Description",
      "Status",
      "SpecGroup",
      "SpecTitle",
      "SpecType",
      "SpecOptions",
    ];

    const sampleRows = [
      [
        "Electronics",
        "Electronic gadgets and devices",
        "active",
        "General",
        "Brand",
        "DROPDOWN LIST",
        "Samsung,Apple,Sony",
      ],
      ["Electronics", "", "", "General", "Warranty", "TEXT", ""],
      [
        "Electronics",
        "",
        "",
        "Features",
        "Connectivity",
        "CHECKBOX",
        "Wi-Fi,Bluetooth,NFC",
      ],
      [
        "Electronics",
        "",
        "",
        "Features",
        "Color",
        "RADIO BUTTON",
        "Black,White,Silver",
      ],
      ["", "", "", "", "", "", ""], // Blank row for readability
      [
        "Clothing",
        "Men's and women's apparel",
        "active",
        "Size",
        "Fit Type",
        "DROPDOWN LIST",
        "Slim,Regular,Loose",
      ],
      ["Clothing", "", "", "Material", "Fabric", "TEXT", ""],
      [
        "Clothing",
        "",
        "",
        "Care",
        "Wash Instructions",
        "CHECKBOX",
        "Machine Wash,Hand Wash,Do Not Bleach",
      ],
    ];

    // Convert to CSV lines
    const csvContent = [
      sampleHeaders.join(","),
      ...sampleRows.map((row) =>
        row
          .map((field) =>
            // Escape fields containing commas, quotes, or newlines
            field.includes(",") || field.includes('"') || field.includes("\n")
              ? `"${field.replace(/"/g, '""')}"`
              : field,
          )
          .join(","),
      ),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Category_Sample_With_Specs.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const applyFilters = () => {
    setIsFilterPanelOpen(false);
  };

  const clearFilters = () => {
    setFilterValues({ status: "" });
    setIsFilterPanelOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isFilterPanelOpen &&
        filterWrapperRef.current &&
        !filterWrapperRef.current.contains(event.target)
      ) {
        setIsFilterPanelOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isFilterPanelOpen]);
  const filterWrapperRef = useRef(null);
  return (
    <>
      <AdminSideBar
        menuContent={menuContent}
        isMinimized={isSidebarMinimized}
      />
      <AdminTopNavBar
        toggleSidebar={toggleSidebar}
        isSidebarMinimized={isSidebarMinimized}
        homeLink={homeLink}
        title="CATEGORIES"
      />
      <div
        className="content-wrapper p-0"
        style={{
          marginLeft: isSidebarMinimized ? "80px" : "250px",
          flex: "1",
        }}
      >
        <section
          style={{
            backgroundColor: "#F1F4F9",
            padding: "30px",
            marginTop: "70px",
            marginBottom: "40px",
          }}
        >
          {fetchLoading ? (
            <p>Loading data...</p>
          ) : (
            <>
              <div className="ps-22 pe-22 pb-22">
                {/* Slider section - Conditionally render only when data exists */}
                {categoryList.length > 0 ? (
                  <Slider {...settings}>
                    {categoryList
                      .filter((category) => category.parentId === 0)
                      .map((category) => (
                        <div
                          key={category.id || category._id}
                          style={{ padding: "10px" }}
                        >
                          <div
                            style={{
                              minWidth: "100px",
                              backgroundColor: "#fff",
                              borderRadius: "5px",
                              padding: "16px",
                              textAlign: "center",
                              height: "150px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                            }}
                          >
                            {/* Image */}
                            <div
                              style={{
                                width: "100%",
                                height: "100px",
                                backgroundImage: `url(${baseURL + "/" + category.imageUrl || "/placeholder.png"})`,
                                backgroundSize: "contain",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                borderRadius: "8px",
                                marginBottom: "5px",
                              }}
                            ></div>
                            {/* Name */}
                            <h5
                              style={{
                                margin: "0",
                                fontSize: "16px",
                                fontWeight: "600",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {category.name || "Unnamed Category"}
                            </h5>
                          </div>
                        </div>
                      ))}
                  </Slider>
                ) : (
                  <></>
                )}
              </div>
              <div
                className="ps-22 pe-22 pb-22 rounded-5"
                style={{ backgroundColor: "#fff" }}
              >
                <div className="row align-items-center pt-32 pb-10">
                  {/* 1. Header */}
                  <div className="col-auto">
                    <h6 className="mb-0">All Categories</h6>
                  </div>

                  {/* 2. Search + Filter */}
                  <div className="col d-flex align-items-center">
                    <div
                      className="filter-wrapper"
                      style={{
                        position: "relative",
                        width: "100%",
                        maxWidth: "500px",
                      }}
                      ref={filterWrapperRef}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #c6d6f5",
                          borderRadius: "8px",
                          backgroundColor: "#fff",
                          width: "100%",
                        }}
                      >
                        <img
                          src="/assets/images/search-icon.png"
                          style={{ width: "18px", marginLeft: "8px" }}
                        />
                        <input
                          type="text"
                          placeholder="Filter and search here..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          onFocus={() => setIsFilterPanelOpen(true)}
                          style={{
                            border: "none",
                            outline: "none",
                            padding: "8px 8px",
                            width: "100%",
                            fontSize: "14px",
                            color: "#333",
                            backgroundColor: "transparent",
                          }}
                          />
                           {searchQuery && (
                                                    <X
                                                      size={24}
                                                      onClick={(e) => {
                                                        e.stopPropagation(); 
                                                        setSearchQuery(""); 
                                                        setCurrentPage(1);
                                                        setIsFilterPanelOpen(false);
                                                      }}
                                                      style={{
                                                        position: "absolute",
                                                        right: "40px", 
                                                        cursor: "pointer",
                                                        color: "#999",
                                                        padding: "4px",
                                                        zIndex: 10,
                                                      }}
                                                      onMouseEnter={(e) =>
                                                        (e.currentTarget.style.color = "#666")
                                                      }
                                                      onMouseLeave={(e) =>
                                                        (e.currentTarget.style.color = "#999")
                                                      }
                                                    />
                                                  )}
                        <ChevronDown
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#999",
                            cursor: "pointer",
                            transform: isFilterPanelOpen
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.2s",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsFilterPanelOpen(!isFilterPanelOpen);
                          }}
                        />
                      </div>

                      {isFilterPanelOpen && (
                        <FilterPanel
                          filterValues={filterValues}
                          onFilterChange={(key, value) =>
                            setFilterValues((prev) => ({
                              ...prev,
                              [key]: value,
                            }))
                          }
                          onSearchChange={setSearchQuery}
                          searchQuery={searchQuery}
                          onApply={applyFilters}
                          onClear={clearFilters}
                        />
                      )}
                    </div>
                  </div>

                  {/* 3. Add New + 4. Options – right-aligned */}
                  <div className="col-auto d-flex align-items-center gap-2">
                    {/* ✅ Add New Button - styled like ListProduct */}
                    {productPermissions.add && (
                      <button
                        className="btn me-0 mb-0"
                        style={{
                          height: "40px",
                          width: "140px",
                          color: "white",
                          backgroundColor: "#2696D5",
                          border: "none",
                          borderRadius: "6px",
                        }}
                        onClick={() =>
                          navigate("/admin/category/categoryAddNew")
                        }
                      >
                        Add New
                      </button>
                    )}

                    {/* ✅ Dropdown */}
                    <CustomDropdown
                      handleDownloadCSV={handleDownloadCSV}
                      handleOpenImportInstructions={() => {
                        if (fileInputRef.current) {
                          fileInputRef.current.value = "";
                          fileInputRef.current.click();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="table-responsive mt-24 product-table">
                  <table className="table table-striped custom-striped-table-product-list align-middle">
                    <thead className="">
                      <tr>
                        <th scope="col" style={{ width: "50px" }}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ borderColor: "#c5d5f5" }}
                            onChange={handleSelectAll}
                            checked={
                              currentItems.length > 0 &&
                              currentItems.every((p) =>
                                selectedData.includes(p.id),
                              )
                            }
                          />
                        </th>
                        <th scope="col" style={{ width: "80px" }}>
                          Image
                        </th>
                        <th scope="col">Categories</th>
                        <th scope="col">Description</th>
                        <th scope="col">Status</th>
                        <th scope="col" style={{ width: "120px" }}>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((category) => (
                          <tr key={category.id}>
                            <td>
                              <input
                                type="checkbox"
                                style={{ borderColor: "#c5d5f5" }}
                                className="form-check-input"
                                checked={selectedData.includes(category.id)}
                                onChange={() => handleSelectOne(category.id)}
                              />
                            </td>
                            <td>
                              <div
                                style={{
                                  backgroundColor: "#e9f0f4",
                                  width: "60px",
                                  height: "60px",
                                  borderRadius: "8px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  src={baseURL + "/" + category.imageUrl}
                                  alt={category.name}
                                  style={{
                                    width: "80%",
                                    height: "80%",
                                    objectFit: "fill",
                                    borderRadius: "8px",
                                  }}
                                />
                              </div>
                            </td>
                            <td
                              style={{
                                width: "20%",
                                textWrap: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              {category.name}
                            </td>
                            <td>
                              <div
                                style={{
                                  maxWidth: "250px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {category.description || ""}
                              </div>
                            </td>
                            <td>
                              <div className="form-check form-switch">
                                <input
                                  className={`form-check-input form-product-status-switch ${
                                    category.status === "active"
                                      ? "switch-green"
                                      : "switch-orange"
                                  }`}
                                  type="checkbox"
                                  id={`statusSwitch-${category.id}`}
                                  checked={category.status === "active"}
                                  onChange={() =>
                                    handleStatusChange(
                                      category.id,
                                      category.status,
                                    )
                                  }
                                />
                              </div>
                            </td>

                            <td style={{ position: "relative" }}>
                              <div className="d-flex gap-1">
                                {productPermissions.view && (
                                  <button
                                    style={{
                                      backgroundColor: "#d9ebff",
                                      height: "39px",
                                      width: "50px",
                                      border: "none",
                                      borderRadius: "4px", // optional
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      padding: "0",
                                      margin: "0",
                                      fontSize: "14px",
                                      lineHeight: 1,
                                      color: "inherit",
                                      outline: "none",
                                    }}
                                    onClick={() => handleView(category.id)}
                                  >
                                    <img
                                      src="/assets/images/view-icon.png"
                                      alt="View"
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        objectFit: "contain",
                                      }}
                                      onError={(e) =>
                                        (e.target.style.display = "none")
                                      }
                                    />
                                  </button>
                                )}

                                {productPermissions.edit && (
                                  <button
                                    style={{
                                      backgroundColor: "#d9ebff",
                                      height: "39px",
                                      width: "50px",
                                      border: "none",
                                      borderRadius: "4px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      padding: "0",
                                      margin: "0",
                                      fontSize: "14px",
                                      lineHeight: 1,
                                      color: "inherit",
                                      outline: "none",
                                    }}
                                    onClick={() => handleEdit(category.id)}
                                  >
                                    <img
                                      src="/assets/images/edit-icon.png"
                                      alt="Edit"
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        objectFit: "contain",
                                      }}
                                      onError={(e) =>
                                        (e.target.style.display = "none")
                                      }
                                    />
                                  </button>
                                )}

                                {productPermissions.delete && (
                                  <button
                                    style={{
                                      backgroundColor: "#d9ebff",
                                      height: "39px",
                                      width: "50px",
                                      border: "none",
                                      borderRadius: "4px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      padding: "0",
                                      margin: "0",
                                      fontSize: "14px",
                                      lineHeight: 1,
                                      color: "inherit",
                                      outline: "none",
                                    }}
                                    onClick={() => handleDelete(category.id)}
                                  >
                                    <img
                                      src="/assets/images/delete-icon.png"
                                      alt="Delete"
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        objectFit: "contain",
                                      }}
                                      onError={(e) =>
                                        (e.target.style.display = "none")
                                      }
                                    />
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            No data found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-16 p-16">
                  <div className="d-flex align-items-center">
                    <select
                      className="form-select d-inline-block w-auto"
                      value={itemsPerPage}
                      onChange={(e) => {
                        const val = e.target.value;
                        setItemsPerPage(val === "all" ? "all" : parseInt(val));
                        setCurrentPage(1);
                      }}
                      style={{
                        height: "34px",
                        fontSize: "14px",
                        minWidth: "70px",
                      }}
                    >
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="all">All</option>
                    </select>
                    <span className="ms-2">
                      Showing {showingFrom} to {showingTo} of{" "}
                      {filteredData.length} Lists
                    </span>
                  </div>
                  <nav>
                    <ul className="pagination mt-0">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          &laquo;
                        </button>
                      </li>
                      {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(
                          1,
                          currentPage - Math.floor(pagesToShow / 2),
                        );
                        let endPage = startPage + pagesToShow - 1;

                        if (endPage > totalPage) {
                          endPage = totalPage;
                          startPage = Math.max(1, endPage - pagesToShow + 1);
                        }

                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                          pageNumbers.push(i);
                        }

                        return pageNumbers.map((pageNum) => (
                          <li
                            key={pageNum}
                            className={`page-item ${
                              currentPage === pageNum ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => paginate(pageNum)}
                            >
                              {pageNum}
                            </button>
                          </li>
                        ));
                      })()}
                      <li
                        className={`page-item ${
                          currentPage === totalPage ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          &raquo;
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </>
          )}
          <AdminFooter isSidebarMinimized={isSidebarMinimized} />
          {/* Import Preview Modal */}
          {isImportModalOpen && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 2000,
                backdropFilter: "blur(2px)",
              }}
              onClick={() => setIsImportModalOpen(false)}
            >
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  width: "90%",
                  maxWidth: "900px",
                  maxHeight: "85vh",
                  overflowY: "auto",
                  padding: "24px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                  border: "1px solid #eee",
                  position: "relative",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={() => {
                    setIsImportModalOpen(false);
                    setImportPreview([]);
                    setFileMap({});
                  }}
                  style={{
                    position: "absolute",
                    borderRadius: "50%",
                    top: "12px",
                    right: "12px",
                    background: "#D9EBFF",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                    color: "#2696D5",
                    width: "28px",
                    height: "28px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  &times;
                </button>
                <h6 className="mb-12">Import Preview</h6>
                <div
                  style={{
                    marginBottom: "20px",
                    fontSize: "14px",
                    color: "#444",
                    lineHeight: "1.6",
                  }}
                >
                  <p style={{ fontWeight: "600", marginBottom: "10px" }}>
                    * Category Name must be unique.
                  </p>
                  <p style={{ fontWeight: "600", marginBottom: "10px" }}>
                    * Please choose an image for each category before importing!
                  </p>
                </div>
                <div
                  className="table-responsive"
                  style={{ maxHeight: "400px", overflowY: "auto" }}
                >
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th>Image</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {importPreview.map((row) => (
                        <tr key={row.id}>
                          <td>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={row.Name}
                              onChange={(e) =>
                                handlePreviewFieldChange(
                                  row.id,
                                  "Name",
                                  e.target.value,
                                )
                              }
                              style={{ fontSize: "12px", width: "120px" }}
                            />
                          </td>
                          <td>
                            <textarea
                              className="form-control form-control-sm"
                              value={row.Description}
                              onChange={(e) =>
                                handlePreviewFieldChange(
                                  row.id,
                                  "Description",
                                  e.target.value,
                                )
                              }
                              rows="2"
                              style={{ fontSize: "11px", width: "150px" }}
                            />
                          </td>
                          <td>
                            <select
                              className="form-select form-select-sm"
                              value={row.Status}
                              onChange={(e) =>
                                handlePreviewFieldChange(
                                  row.id,
                                  "Status",
                                  e.target.value,
                                )
                              }
                              style={{ fontSize: "12px", width: "90px" }}
                            >
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                            </select>
                          </td>
                          <td>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                setFileMap((prev) => ({
                                  ...prev,
                                  [row.id]: e.target.files[0],
                                }))
                              }
                              style={{ fontSize: "11px" }}
                            />
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <button
                              type="button"
                              onClick={() =>
                                setImportPreview((prev) =>
                                  prev.filter((r) => r.id !== row.id),
                                )
                              }
                              style={{
                                background: "none",
                                border: "none",
                                color: "#e74c3c",
                                cursor: "pointer",
                                padding: "4px",
                              }}
                            >
                              <Trash2 size={16} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div
                  style={{
                    marginTop: "20px",
                    textAlign: "right",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setIsImportModalOpen(false);
                      setImportPreview([]);
                      setFileMap({});
                    }}
                    style={{ height: "40px" }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleStartImport}
                    disabled={importPreview.length === 0}
                    style={{ height: "40px" }}
                  >
                    Start Import
                  </button>
                </div>
              </div>
            </div>
          )}
        </section>
      </div>
      {/* Hidden file input for CSV import */}
      <input
        type="file"
        ref={fileInputRef}
        accept=".csv"
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
    </>
  );
};
export default ListCategory;

const CustomDropdown = ({
  handleDownloadCSV,
  handleOpenImportInstructions,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Options");
  const [isHovered, setIsHovered] = useState(false);

   const options = [
    { label: "Export", value: "export" },
    { label: "Export All", value: "exportAll" },
    { label: "Import", value: "import" },
  ];
  const handleSelect = (opt) => {
    setSelected(opt.label);
    setIsOpen(false);

    if (opt.value === "export") {
      handleDownloadCSV("current");
    } else if (opt.value === "exportAll") {
      handleDownloadCSV("all");
    } else if (opt.value === "import") {
      handleOpenImportInstructions();
    }

    setSelected("Options");
  };
  
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);
  return (
    <div
      className="custom-select"
      style={{ position: "relative", display: "inline-block" }}
      ref={dropdownRef}
    >
      <div
        className="select-header"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          backgroundColor: isHovered ? "#EDF8FA" : "#fff",
          color: "rgba(129, 134, 134, 1)",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          cursor: "pointer",
          width: "140px",
          height: "40px",
          textAlign: "left",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 500,
          transition: "background-color 0.2s ease",
        }}
      >
        <span>{selected}</span>
        <ChevronDown />
      </div>
      {isOpen && (
        <ul
          className="select-options"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            backgroundColor: "white",
            border: "none",
            borderRadius: "4px",
            zIndex: 1000,
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: 500,
          }}
        >
          {options.map((opt) => (
            <li
              key={opt.value}
              onClick={() => handleSelect(opt)}
              className="select-option"
              style={{
                padding: "8px 12px",
                color: "rgba(129, 134, 134, 1)",
                backgroundColor: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const FilterPanel = ({
  filterValues,
  onFilterChange,
  onApply,
  onClear,
  searchQuery,
  onSearchChange,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "500px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        zIndex: 1000,
        padding: "16px",
        maxHeight: "400px",
        overflowY: "auto",
        marginTop: "10px",
      }}
    >
      <div className="row g-3">
        {/* Status Filter */}
        <div className="col-12 mb-22">
          <select
            className="form-select"
            value={filterValues.status || ""}
            onChange={(e) => onFilterChange("status", e.target.value)}
          >
            <option value="">All Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </div>

      <div className="d-flex gap-2 mt-3">
        <button
          onClick={onApply}
          style={{
            color: "#fff",
            backgroundColor: "#2b95d3",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "120px",
            height: "40px",
            border: "none",
          }}
        >
          Apply
        </button>
        <button
          onClick={onClear}
          style={{
            color: "#2692d2",
            backgroundColor: "#d9ebff",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "120px",
            height: "40px",
            border: "none",
          }}
        >
          Clear
        </button>
      </div>
    </div>
  );
};
